var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseWithWhiteFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close with white fill bg",
    clipPath: "url(#clip0_477_23960)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.583 2.06027C15.9656 2.85855 17.1157 4.00408 17.9195 5.38346C18.7233 6.76283 19.1529 8.32822 19.1658 9.92466C19.1787 11.5211 18.7744 13.0932 17.993 14.4854C17.2116 15.8776 16.0801 17.0415 14.7106 17.8621C13.3411 18.6826 11.7811 19.1312 10.1849 19.1635C8.58877 19.1958 7.01184 18.8107 5.61026 18.0462C4.20869 17.2818 3.03106 16.1646 2.19395 14.8052C1.35685 13.4457 0.8893 11.8912 0.837591 10.2956L0.833008 9.9986L0.837591 9.7016C0.888927 8.11851 1.34959 6.57573 2.17468 5.22367C2.99976 3.87162 4.16111 2.75643 5.54549 1.98682C6.92988 1.21722 8.49006 0.819463 10.0739 0.832334C11.6578 0.845205 13.2113 1.26826 14.583 2.06027Z",
    fill: "#454551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 6 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9225 6.07871C14.2479 6.40415 14.2479 6.93179 13.9225 7.25722L7.2558 13.9239C6.93036 14.2493 6.40272 14.2493 6.07729 13.9239C5.75185 13.5985 5.75185 13.0708 6.07728 12.7454L12.744 6.07871C13.0694 5.75328 13.597 5.75328 13.9225 6.07871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 7 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.07774 6.07754C6.40317 5.7521 6.93081 5.7521 7.25625 6.07754L13.9229 12.7442C14.2484 13.0696 14.2484 13.5973 13.9229 13.9227C13.5975 14.2482 13.0698 14.2482 12.7444 13.9227L6.07774 7.25605C5.7523 6.93061 5.7523 6.40297 6.07774 6.07754Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_477_23960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWithWhiteFill);
export default __webpack_public_path__ + "static/media/close-with-white-fill.81d7797fb714b711c618d9ee7e94cbcc.svg";
export { ForwardRef as ReactComponent };